import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody, Col, Row } from "reactstrap";

import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Loader from "../../../../Components/Common/Loader";
import { widgetDataOrgaApp } from "../../../../common/data";

const WidgetOrganisateur = ( props ) =>
{
  const [ widgetData, setWidgetData ] = useState( [] );

  const fetchData = async () =>
  {
    const getWidgetData = await widgetDataOrgaApp();
      // console.log( "getWidgetData: ", getWidgetData );
    setWidgetData( getWidgetData );
  };
  
  useEffect( () =>
  {

    fetchData();
  }, [] );

  return (
    <Row >
      { widgetData.length > 0 ? (
        widgetData.map( ( item, key ) => (
          <Col md={ 4 } key={ key }>
            <Card className="card-animate card-height-100">
              <CardBody>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 overflow-hidden">
                    <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                      { props.t( item.label ) }
                    </p>
                  </div>
                </div>
                <div className="d-flex align-items-end justify-content-between mt-4">
                  <div>
                    <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                      <span className="counter-value" data-target="559.25">
                        <CountUp
                          start={ 0 }
                          prefix={ item.prefix }
                          suffix={ item.suffix }
                          separator={ item.separator }
                          end={ item.counter }
                          decimals={ item.decimals }
                          duration={ 4 }
                        />
                      </span>
                    </h4>
                    <Link
                      to={ item.location }
                      className="text-decoration-underline"
                    >
                      { props.t( item.link ) }
                    </Link>
                  </div>
                  <div className="avatar-sm flex-shrink-0">
                    <span
                      className={
                        "avatar-title rounded fs-3 bg-soft-" + item.bgcolor
                      }
                    >
                      <i
                        className={ `text-${ item.bgcolor } ${ item.icon }` }
                      ></i>
                    </span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ) )
      ) : (
        <>
          <Col md={ 12 }>
            <Card className="h-100 w-100">
              <CardBody>
                <div className="text-center my-3">
                  <Loader style={ { color: "#014c94" } } />
                  <h2>Chargement...</h2>
                </div>
              </CardBody>
            </Card>
          </Col>
        </>
      ) }
    </Row>
  );
};

WidgetOrganisateur.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default ( withTranslation()( WidgetOrganisateur ) );
